var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { FieldsetDataHooks } from './types';
import { classes, st } from './Fieldset.st.css';
import ErrorSmall from 'wix-ui-icons-common/on-stage/ErrorSmall';
export var Fieldset = React.forwardRef(function (_a, ref) {
    var children = _a.children, label = _a.label, errorMessage = _a.errorMessage, labelId = _a.labelId, errorMessageId = _a.errorMessageId, dataHook = _a.dataHook, className = _a.className, props = __rest(_a, ["children", "label", "errorMessage", "labelId", "errorMessageId", "dataHook", "className"]);
    return (React.createElement("fieldset", __assign({ className: st(classes.root, {
            error: Boolean(errorMessage),
        }, className), "data-hook": dataHook, ref: ref }, props),
        label && (React.createElement("legend", { id: labelId, className: classes.label }, label)),
        children,
        errorMessage && (React.createElement("div", { className: classes.error, id: errorMessageId, "data-hook": FieldsetDataHooks.Error },
            React.createElement(ErrorSmall, { "aria-hidden": true, className: classes.errorIcon }),
            errorMessage))));
});
//# sourceMappingURL=Fieldset.js.map